// Validate required environment variables
const validateEnvVars = () => {
  const required = {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    monthlyPriceId: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID,
    yearlyPriceId: process.env.REACT_APP_STRIPE_YEARLY_PRICE_ID
  };

  const missing = Object.entries(required)
    .filter(([_, value]) => !value)
    .map(([key]) => `REACT_APP_STRIPE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`);

  if (missing.length > 0 && process.env.NODE_ENV === 'production') {
    throw new Error(`Missing required Stripe environment variables: ${missing.join(', ')}`);
  }

  return required;
};

const envVars = validateEnvVars();

export const STRIPE_CONFIG = {
  // Stripe public key - validated on load
  publishableKey: envVars.publishableKey || 'pk_test_fallback_for_dev',

  // Product and price configuration
  products: {
    monthly: {
      priceId: envVars.monthlyPriceId || 'price_monthly_test',
      price: 2.99,  // Updated from $7.99 - lower barrier to entry
      currency: 'usd',
      interval: 'month'
    },
    yearly: {
      priceId: envVars.yearlyPriceId || 'price_yearly_test',
      price: 24.99,  // Updated from $35.99 - saves $11/year vs monthly
      currency: 'usd',
      interval: 'year',
      discount: 31 // Saves $11/year vs monthly ($35.88 - $24.99)
    }
  },

  // Checkout settings
  checkout: {
    mode: 'subscription' as const,
    success_url: `${window.location.origin}/success`,
    cancel_url: `${window.location.origin}/`,
    allow_promotion_codes: true,
    billing_address_collection: 'auto' as const,
    payment_method_types: ['card', 'paypal'] as const,
    // TWA-friendly settings
    locale: 'auto' as const,
  }
};

export const isStripeConfigured = () => {
  return STRIPE_CONFIG.publishableKey.startsWith('pk_');
};